export const programOrigin = [
  { label: "Corporativo", value: "CORPORATE" },
  { label: "Gobierno", value: "GOVERNMENT" },
  { label: "Privado", value: "PRIVATE" },
  { label: "Universidad", value: "UNIVERSITY" },
  { label: "Otro", value: "OTHER" }
];
